import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */

const { Types, Creators } = createActions({
  getClientesRequest: null,
  getClientesSuccess: ['clientes'],
  getClientesFailure: ['error'],
  addClienteRequest: ['cliente', 'closeModal'],
  addClienteSuccess: ['cliente'],
  addClienteFailure: ['error'],
  updateClienteRequest: ['cliente', 'closeModal'],
  updateClienteSuccess: ['cliente'],
  updateClienteFailure: ['error'],
  removeClienteRequest: ['id'],
  removeClienteSuccess: ['id'],
  removeClienteFailure: ['error'],
  openModal: null,
  closeModal: null,
  setClienteActive: ['cliente'],
});

export const ClientesTypes = Types;
export default Creators;

/* Initial State */

export const INITIAL_STATE = Immutable({
  clientes: [],
  clienteActive: null,
  isLoading: false,
  error: null,
  openModal: false,
});

/* Reducers */

const getClientesRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const getClientesSuccess = (state, { clientes }) =>
  state.merge({
    clientes,
    isLoading: false,
    error: null,
  });

const getClientesFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const addClienteRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const addClienteSuccess = (state, { cliente }) =>
  state.merge({
    clientes: [...state.clientes, cliente],
    isLoading: false,
    error: null,
  });

const addClienteFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const updateClienteRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const updateClienteSuccess = (state, { cliente }) =>
  state.merge({
    clientes: state.clientes.map((item) =>
      item.id === cliente.id ? cliente : item
    ),
    isLoading: false,
    error: null,
  });

const updateClienteFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const removeClienteRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const removeClienteSuccess = (state, { id }) =>
  state.merge({
    clientes: state.clientes.filter((item) => item.id !== id),
    isLoading: false,
    error: null,
  });

const removeClienteFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const openModal = (state) =>
  state.merge({
    openModal: true,
  });

const closeModal = (state) =>
  state.merge({
    openModal: false,
    clienteActive: null,
  });

const setClienteActive = (state, { cliente }) =>
  state.merge({
    clienteActive: cliente,
  });

/* Reducers to types */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_CLIENTES_REQUEST]: getClientesRequest,
  [Types.GET_CLIENTES_SUCCESS]: getClientesSuccess,
  [Types.GET_CLIENTES_FAILURE]: getClientesFailure,
  [Types.ADD_CLIENTE_REQUEST]: addClienteRequest,
  [Types.ADD_CLIENTE_SUCCESS]: addClienteSuccess,
  [Types.ADD_CLIENTE_FAILURE]: addClienteFailure,
  [Types.UPDATE_CLIENTE_REQUEST]: updateClienteRequest,
  [Types.UPDATE_CLIENTE_SUCCESS]: updateClienteSuccess,
  [Types.UPDATE_CLIENTE_FAILURE]: updateClienteFailure,
  [Types.REMOVE_CLIENTE_REQUEST]: removeClienteRequest,
  [Types.REMOVE_CLIENTE_SUCCESS]: removeClienteSuccess,
  [Types.REMOVE_CLIENTE_FAILURE]: removeClienteFailure,
  [Types.OPEN_MODAL]: openModal,
  [Types.CLOSE_MODAL]: closeModal,
  [Types.SET_CLIENTE_ACTIVE]: setClienteActive,
});

